export const SECONDS_IN_MINUTE = 60;
export const MINUTES_IN_HOUR = 60;
export const MILLISECONDS_IN_SECOND = 1000;
export const MILLISECONDS_IN_DAY = 86400000;

export const DEFAULT_STALE_TIME = 5 * SECONDS_IN_MINUTE * MILLISECONDS_IN_SECOND;
